import { Injectable } from '@angular/core';
import { Translation } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { Resolver } from '@nibtravel/shared/util/i18n';
import { Observable } from 'rxjs';

import { UiContentSelector } from './state';

@Injectable({ providedIn: 'root' })
export class BrandContentResolver implements Resolver {
  constructor(private store: Store) {}

  // Need to think about language moving forward
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public load(lang: string, scope: string): Observable<Translation> {
    return this.store.selectOnce(UiContentSelector.getBrandContents);
  }
}
